import { IoExitOutline } from "react-icons/io5";
import { useContext } from "react";
import { UserContext } from "../../context/UserContext";
import Translation from "../Translation/Translation";
import { useTranslation } from "react-i18next";
import { logout } from "../../logout";
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import { Button, Stack } from '@mui/material';

export type logoutType = {
  userEmpresa: string,
  userToken: string,
  username: string,
};

export default function Header() {
  const { isHidden, setIsHidden } = useContext(UserContext);
  const { t } = useTranslation('translation');

  return (
    <AppBar
      position='static'>
      <Toolbar sx={{ backgroundColor: 'white', color: 'gray' }}>
        <IconButton
          onClick={() => setIsHidden(!isHidden)}
          size="large"
          edge="start"
          aria-label="menu"
          sx={{ color: 'white' }}
        >
          <MenuIcon fontSize='large' sx={{ backgroundColor: '#2EA689' }} />
        </IconButton >
        <Stack
          width={'100%'}
          direction="row"
          alignItems="center"
        >
          <Stack
            width={'100%'}
            direction="row"
            justifyContent="center"
            alignItems="center"

          >
            <Translation header={true} />
          </Stack>
          <Stack
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            spacing={12}
          >
            <Button sx={{ color: 'gray' }} onClick={() => logout()} endIcon={<IoExitOutline />}>
              {t('header.exitButton')}
            </Button>
          </Stack>
        </Stack>
      </Toolbar>
    </AppBar>

  );
}
